"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = VideoPlayer;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("../../utils/utils");
var _reactPlayer = _interopRequireDefault(require("react-player"));
// Packages

// Styles
const PlayerWrapper = _styledComponents.default.div.withConfig({
  displayName: "video-player__PlayerWrapper",
  componentId: "sc-18ud0zh-0"
})(["height:100%;padding-top:56.25%;position:relative;width:100%;.react-player{left:0;position:absolute;top:0;}"]);

// Main Component
function VideoPlayer({
  url,
  playerColor,
  additionalOptions,
  videoHost,
  controls
}) {
  return /*#__PURE__*/_react.default.createElement(PlayerWrapper, {
    className: "player-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_reactPlayer.default, {
    url: url,
    className: "react-player",
    width: "100%",
    height: "100%",
    controls: controls,
    config: {
      [videoHost]: {
        options: {
          ...additionalOptions,
          playerColor,
          doNotTrack: true,
          fullscreenButton: true
        }
      }
    }
  }));
}

// Prop Types
VideoPlayer.propTypes = {
  /**
   * Url of video
   */
  url: _propTypes.default.string.isRequired,
  /**
   * Base color of the player
   */
  playerColor: _propTypes.default.string,
  /**
   * Object containing additional customization options
   */
  additionalOptions: _propTypes.default.shape(),
  /**
   * Video host (Wistia, Youtube, etc.)
   */
  videoHost: _propTypes.default.string
};
VideoPlayer.defaultProps = {
  controls: true,
  playerColor: _utils.colors["pacific-blue"].hex,
  videoHost: "wistia"
};
VideoPlayer.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "VideoPlayer",
  "props": {
    "controls": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "playerColor": {
      "defaultValue": {
        "value": "colors[\"pacific-blue\"].hex",
        "computed": true
      },
      "description": "Base color of the player",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "videoHost": {
      "defaultValue": {
        "value": "\"wistia\"",
        "computed": false
      },
      "description": "Video host (Wistia, Youtube, etc.)",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "url": {
      "description": "Url of video",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "additionalOptions": {
      "description": "Object containing additional customization options",
      "type": {
        "name": "shape",
        "value": "PropTypes.shape()",
        "computed": true
      },
      "required": false
    }
  }
};